import React from "react";

const Bash_Df = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Df</h2>
      <p>Report filesystem disk space usage.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>df [options] [file]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>df -h
df -i</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -h for human-readable sizes.</p>
    </div>
  );
};

export default Bash_Df;
